import './env-loader'
import './utils/rem'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/scss/index.scss'
import './utils/icon'
import App from './App.vue'
import router from './router'

import RequestPlugin from '@/utils/request'
import Icon from './components/Icon.vue'
import xEllipsis from './components/x-ellipsis.vue'
import clipboard from './directive/clipboard'
import CountTo from 'vue-count-to'

Vue.component('count-to', CountTo)
Vue.component('Icon', Icon)
Vue.component('xEllipsis', xEllipsis)
Vue.use(ElementUI, {
  size: 'mini'
})

Vue.directive('clipboard', clipboard)

Vue.config.productionTip = false

Vue.prototype.$request = RequestPlugin.request

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
